import { ReactNode } from 'react';
import Flex from '@creditflowresearch/uilib/Flex';

import styles from './expandedContent.module.scss';

interface IExpandedContentProps {
  dataTest?: string,
  children?: ReactNode,
}

const ExpandedContent = ({
  dataTest = 'expandedContent',
  children,
}: IExpandedContentProps) => {
  return (
    <Flex
      direction="column"
      className={ styles.expandedContent }
      data-test={ dataTest }
    >
      { children }
    </Flex>
  );
};

export default ExpandedContent;
